module.exports = __webpack_public_path__ + "static/media/settings.2a3b8408.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/manual/settings.jpg
// module id = 1865
// module chunks = 0